define.alias("shared/components/shared/button/boost", "media/components/shared/button/boost");